var map = {
	"./bloqhouse.png": "61a6",
	"./bloqhouse.svg": "95f2",
	"./idin.svg": "3fca",
	"./logo-white.svg": "011a",
	"./logo.svg": "df2f",
	"./mollie-logo.svg": "4674",
	"./mollie-secured.svg": "76a0",
	"./pebbles-white.svg": "3cbe",
	"./pebbles.svg": "7688"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1a";